(ns common.schema.entities.ai-task-config
  "Per-tenant configuration for one AI task type. It selects an AI service,
   token-warning destination, and optional output configuration. The
   tenant-wide default service lives on :tenant/ai-default-service; rows here
   are per-task-type overrides."
  (:require [common.schema.entities.integration.ai-options :as ai-options]
            [common.schema.schema-utils :as su]))

(def schema
  (vec
   (concat
    (su/keyword-field :ai-task-config/task-type "Task type" ai-options/task-type-options
                      {:authorization su/access-admin-admin})
    (su/single-ref-field :ai-task-config/service "AI service"
                         [:entity.type/ai-service]
                         {:authorization su/access-admin-admin})
    (su/email-field :ai-task-config/token-warning-email "Token warning email"
                    {:authorization su/access-admin-admin})
    (su/url-field :ai-task-config/style-reference-url
                  "Style reference URL"
                  {:authorization su/access-admin-admin})
    (su/single-ref-field :ai-task-config/document-template
                         "Document template"
                         [:entity.type/attachment]
                         {:authorization su/access-admin-admin})
    (su/text-simple-multi-field :ai-task-config/internal-email-domains
                                "Internal email domains"
                                {:authorization su/access-admin-admin}))))
